import type { GeometryDataTyped } from "@/types/blocks.types";
import {
  ParametricAssetId,
  SubmittingOrganization,
  type ParametricAsset,
} from "@/types";

type AssetParams = {
  r: number; // Rayon du cylindre
  a: number; // Longueur du premier cylindre
  b: number; // Longueur des cylindres intermédiaires
  x: number; // Nombre de cylindres intermédiaires
  c: number; // Longueur du dernier cylindre
};

const asset: ParametricAsset<AssetParams> = {
  id: ParametricAssetId.CULVERT_UNFOLDED_VIEW,
  image: "/images/assets/developpe-buse.png",
  submittedBy: SubmittingOrganization.GETEC,
  inputs: [
    { key: "r", type: "dimension" },
    { key: "a", type: "dimension" },
    {
      key: "b",
      type: "dimension",
    },
    { key: "x", type: "quantity" },
    { key: "c", type: "dimension" },
  ],
  build: (params, offset) => {
    const { a, b, c, r, x } = params;

    const h = r * Math.PI * 2;

    const polylines: GeometryDataTyped[] = [];

    // Premier cylindre
    polylines.push({
      type: "polyline",
      points: [
        [offset[0], offset[1], offset[2]],
        [offset[0] + a, offset[1], offset[2]],
        [offset[0] + a, offset[1] + h, offset[2]],
        [offset[0], offset[1] + h, offset[2]],
        [offset[0], offset[1], offset[2]],
      ],
    });

    // Cylindres intermédiaires
    for (let i = 0; i < x; i++) {
      const startX = offset[0] + a + i * b;
      polylines.push({
        type: "polyline",
        points: [
          [startX, offset[1], offset[2]],
          [startX + b, offset[1], offset[2]],
          [startX + b, offset[1] + h, offset[2]],
          [startX, offset[1] + h, offset[2]],
          [startX, offset[1], offset[2]],
        ],
      });
    }

    // Dernier cylindre
    const lastStartX = offset[0] + a + x * b;
    polylines.push({
      type: "polyline",
      points: [
        [lastStartX, offset[1], offset[2]],
        [lastStartX + c, offset[1], offset[2]],
        [lastStartX + c, offset[1] + h, offset[2]],
        [lastStartX, offset[1] + h, offset[2]],
        [lastStartX, offset[1], offset[2]],
      ],
    });

    return polylines;
  },
};
export default asset;
